export class DialogTaxAddressData {
  action: DialogTaxAddressActionType;
  data: any;
}

export enum DialogTaxAddressActionType {
  UPDATE_ADDRESS,
  CANCEL
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-tax-address/dialog-tax-address.model.ts